/**
 * Utility which allows resolution of resourceful odata context.
 * @module @nhtio/lucid-resourceful/odata/context
 */
import { E_NOT_IN_ODATA_CONTEXT } from '@nhtio/lucid-resourceful/errors'
import { ODataContext } from '@/private/odata_macro/services/odata_context_service'
import type { ResolvedODataContext } from '@/private/odata_macro/services/odata_context_service'

export const useODataContext = async (): Promise<ResolvedODataContext> => {
  try {
    const store = ODataContext.getStore()
    if (!store || !('resolver' in store) || 'function' !== typeof store.resolver) {
      throw new E_NOT_IN_ODATA_CONTEXT()
    }
    return await store.resolver()
  } catch (err) {
    throw new E_NOT_IN_ODATA_CONTEXT(err)
  }
}

export type { ResolvedODataContext }
